// extracted by mini-css-extract-plugin
export var active = "MobileCategoryFilter-module--active--b0606";
export var arrow = "MobileCategoryFilter-module--arrow--98474";
export var clearBtn = "MobileCategoryFilter-module--clearBtn--94818";
export var dropdown = "MobileCategoryFilter-module--dropdown--99dd6";
export var item = "MobileCategoryFilter-module--item--8f48a";
export var list = "MobileCategoryFilter-module--list--e15b4";
export var root = "MobileCategoryFilter-module--root--40927";
export var select = "MobileCategoryFilter-module--select--2064a";